export function isTransientRequestError(error) {
  if (!error) return false;

  const status = Number(error.status || error.body?.status);
  if ([408, 425, 429, 500, 502, 503, 504].includes(status)) {
    return true;
  }

  const name = String(error.name || '');
  const message = String(error.message || '');
  if (name === 'TypeError' || name === 'FetchError') return true;
  return (
    /networkerror|failed to fetch|network request failed|load failed|err_network|econnreset|econnrefused|etimedout|socket/i.test(
      message
    )
  );
}
